import React from "react";
import Rewards from "./Rewards";
import "./Machine.sass";
import Future from "./Future";
import Team from "./Team";
import Casino from "./Casino";

export default function Machine() {
  return (
    <div
      className="machine"
      style={{
        background: "url('/images/machine-bg.png')",
        backgroundSize: "contain",
        backgroundRepeat: "no-repeat",
        width: "100%",
        height: "0",
        paddingBottom: "375%",
      }}
    >
      <div className="machine-header">
        <div className="machine-header-text">
          <h2 className="machine-header-title">Uncle Elon’s Dream Machine!</h2>
          <h3 className="machine-header-subtitle">
            GIVEN TO UNCLE ELON THROUGH DIVINE INTERVENTION FROM KEK
          </h3>
          <p className="machine-header-description">
            The beating heart of the Frenconomy and Central Means of production
            for all goods and services
          </p>
        </div>
        <div className="machine-header-image">
          <img src="/images/gh.png" alt="elon" />
        </div>
      </div>
      <h3 className="machine-header-subtitle-mobile">
        GIVEN TO UNCLE ELONG THROUGH DIVINE INTERVENTION FROM KEK
      </h3>
      <p className="machine-header-description-mobile">
        The beating heart of the Frenconomy and Central Means of production for
        all goods and services
      </p>

      <Rewards />
      <Future />
      <Team />
      <Casino />
    </div>
  );
}
